<template>
  <article class="analysisA">
    <ul class="tab-service-detail">
      <li v-for="(item, index) in tabList" @click="onShiftTab(item)" :class="{on:item.on}" :key="index">
        <a href="javascript:void(0);">{{item.name}}</a>
      </li>
    </ul>
    <div class="blank"></div>
    <div class="car-all">
      <cell :title="group.group_name" class="top-title" v-if="tabList[0].on && tabList[0].id === 'date'">
        <span slot="after-title" class="title-date">{{"|&nbsp;&nbsp;" + day}}</span>
        <button
          slot="child"
          @click="onTabChange({filter: 'today', bool: true})"
          :class="{'btn-select': flagA, 'btn-default': !flagA}">今天</button>
        <button
          slot="child"
          @click="onTabChange({filter: 'yestoday', bool: false})"
          :class="[{'btn-select': !flagA, 'btn-default': flagA}, 'btn-margin']">昨天</button>
      </cell>
      <cell :title="group.group_name" class="top-title" v-else>
        <span slot="after-title" class="title-date">{{"|&nbsp;&nbsp;" + day}}</span>
        <button
          slot="child"
          @click="onTabChange({filter: 'this_month', bool: true})"
          :class="{'btn-select': flagA, 'btn-default': !flagA}">本月</button>
        <button
          slot="child"
          @click="onTabChange({filter: 'last_month', bool: false})"
          :class="[{'btn-select': !flagA, 'btn-default': flagA}, 'btn-margin']" >上个月</button>
      </cell>
      <div v-if="tabList[1].on && tabList[1].id === 'month'">
        <p class="table-title">到店转成交漏斗分析(可选择3家店进行对比)</p>
        <div class="add-stores">
          <ul>
            <li v-for="(store, index) in stores" :key="index">
              {{ store.value }}
            </li>
          </ul>
          <!--<x-button
            class="add_store_btn"
            :mini="true"
            type="primary"
            :plain="true"
            @click="show = !show">{{ stores.length === 3 ? '编辑' : '+添加' }}</x-button>-->
          <x-button
            class="add_store_btn"
            :mini="true"
            type="primary"
            :plain="true"
            @click="show = !show"
            v-html="stores.length === 3 ? storeIcons[1]: storeIcons[0]"
          ></x-button>
        </div>
        <div v-transfer-dom>
          <popup v-model="show">
            <div class="popup0">
              <group>
                <p class="table-title">到店转成交漏斗分析 (可选择3家店进行对比)</p>
                <checklist :options="allStores" v-model="selectedStores" label-position="right" :min="0" :max="max"></checklist>
                <x-button type="primary" @click="getDealFilters">确认</x-button>
              </group>
            </div>
          </popup>
        </div>
        <group class="filters">
          <cell class="title">
            <p slot="after-title">
              <span>&nbsp;指标</span>
              <i v-for="(store, index) in stores" :class="`store-name${index}`" class="store-name" :key="index">
                {{ store.value ? store.value : '--'}}
              </i>
            </p>
          </cell>
          <cell class="one">
            <p slot="after-title"><span>到店量(客流)</span>
            <em class="p-em" v-for="(item, index) in subStores" :key="index">{{ item.arrived }}</em></p>
          </cell>
          <cell class="two">
            <p slot="after-title">
              <span>草签数</span>
              <em class="p-em" :class="`p-em${index}`" v-for="(item, index) in subStores" :key="index">{{ item.review }}</em>
            </p>
          </cell>
          <cell class="three">
            <p slot="after-title">
              <span>成交数</span>
              <em class="p-em" :class="`p-em${index}`" v-for="(item, index) in subStores" :key="index">{{ item.deal }}</em></p>
          </cell>
        </group>
        <p class="table-title">销售展厅指标统计</p>
        <a-card
          config="groupConfig"
          ref="group"
          :number="num"
          first-field="store_name"
          :is-scroll="true"
          :params="{filter: this.filter}">
          <th slot="title">门店</th>
        </a-card>
        <div v-if="tabList[1].on && tabList[1].id === 'month'">
          <p class="table-title">潜客线索转成交漏斗分析(可选择3家店进行对比)</p>
          <div class="add-stores">
            <ul>
              <li v-for="(clue, index) in clues" :key="index">
                {{ clue.value }}
              </li>
            </ul>
            <x-button
              class="add_store_btn"
              :mini="true"
              type="primary"
              :plain="true"
              v-html="clues.length === 3 ? storeIcons[1] : storeIcons[0]"
              @click="showClue = !showClue">
            </x-button>
          </div>
        </div>
        <div v-transfer-dom>
          <popup v-model="showClue">
            <div class="popup0">
              <group>
                <p class="table-title">潜客线索转成交漏斗分析(可选择3家店进行对比)</p>
                <checklist class="store-list" :options="allStores" v-model="selectedClues" label-position="right" :max="max"></checklist>
                <x-button type="primary" @click="getClueFilters">确认</x-button>
              </group>
            </div>
          </popup>
        </div>
        <group class="filters">
          <cell class="title">
            <p slot="after-title">
              <span>&nbsp;指标</span>
              <i v-for="(clue, index) in clues" :class="`store-name${index}`" :key="index" class="store-name">
                {{ clue.value ? clue.value : '--'}}
              </i>
            </p>
          </cell>
          <cell class="one">
            <p slot="after-title">
              <span>线索数</span>
              <em class="p-em" v-for="(item, index) in subClues" :key="index">{{ item.clue }}</em></p>
          </cell>
          <cell class="two">
            <p slot="after-title">
              <span>到店数</span>
              <em class="p-em" :class="`p-em${index}`" v-for="(item, index) in subClues" :key="index">{{ item.arrived }}</em></p>
          </cell>
          <cell class="three">
            <p slot="after-title">
              <span>成交数</span>
              <em class="p-em" :class="`p-em${index}`"  v-for="(item, index) in subClues" :key="index">{{ item.deal }}</em>
            </p>
          </cell>
        </group>
        <p class="table-title">潜客到店成交指标统计</p>
        <a-card config="culeArrived" ref="clues" first-field="store_name" :params="{filter: this.filter}">
          <th slot="title">门店</th>
        </a-card>
      </div>
      <div v-else>
        <p class="table-title">销售展厅指标统计</p>
        <a-card
          config="groupConfig"
          ref="group"
          first-field="store_name"
          :is-scroll="true"
          :number="num"
          :params="{filter: this.filter}">
          <th slot="title">门店</th>
        </a-card>
        <p class="table-title">潜客到店成交指标统计</p>
        <a-card
          config="culeArrived"
          ref="clues"
          first-field="store_name"
          :params="{filter: this.filter}">
          <th slot="title">门店</th>
        </a-card>
      </div>
    </div>
  </article>
</template>
<script>
import util from '../../common/util'
import ACard from './components/ACard'
import {
  Cell,
  TransferDom,
  Group,
  Popup,
  Checklist,
  XButton
} from '@lx-frontend/cvux'
export default {
  directives: {
    TransferDom
  },
  components: {
    Cell,
    XButton,
    Checklist,
    Popup,
    Group,
    ACard
  },
  computed: {
    stores () {
      let arr = []
      this.selectedStores.forEach(item => {
        this.allStores.forEach(store => {
          if (item === store.key) {
            arr.push(store)
          }
        })
      })
      return arr
    },
    clues () {
      let arr = []
      this.selectedClues.forEach(item => {
        this.allStores.forEach(store => {
          if (item === store.key) {
            arr.push(store)
          }
        })
      })
      return arr
    }
  },
  data () {
    return {
      num: 1,
      max: 3,
      hasGroupAuth: false,
      show: false,
      showClue: false,
      group: {},
      selectedStores: [],
      allStores: [],
      subStores: [],
      allClues: [],
      selectedClues: [],
      subClues: [],
      storeIcons: ['<i class="store-icon store-add-icon"></i>添加', '<i class="store-icon store-edit-icon"></i>编辑'],
      filter: 'this_month',
      day: util.formatTime(new Date(), 'yyyy-MM'), // 默认显示本月
      flagA: true, // 默认日期是今天/本月
      tabList: [{
        id: 'date',
        name: '日',
        on: false
      }, {
        id: 'month',
        name: '月',
        on: true
      }]
    }
  },
  created () {
    this.getGroupInfo()
    this.getCurrentStores()
    this.getType()
  },
  methods: {
    getType () {
      const type = this.$route.query.type
      let index = 1

      if (type) {
        index = parseFloat(type)
      }

      this.onShiftTab(this.tabList[index])
    },
    onShiftTab (item) {
      this.tabList.forEach((tab) => {
        if (item.id === tab.id) {
          tab.on = true
        } else {
          tab.on = false
        }
      })
      if (item.on && item.id === 'date') {
        this.num = 0
        this.flagA = true
        this.filter = 'today'
        this.getData()
        this.getCurrentTime()
      } else {
        this.num = 1
        this.flagA = true
        this.filter = 'this_month'
        this.getData()
        this.getCurrentTime()
      }
    },
    getGroupInfo () {
      this.$rest.dataAnalysis.getCurrentGroup().then(res => {
        if (res.code === 0) {
          this.group = res.data
        } else {
          this.showToast(res.message)
        }
      })
    },
    // 获取当前集团下的所有店铺
    getCurrentStores () {
      this.$rest.dataAnalysis.getAllStores().then(res => {
        if (res.code === 0) {
          res.data.forEach(item => {
            this.allStores.push({
              key: item.id,
              value: item.name
            })
          })
        } else {
          this.showToast(res.message)
        }
      })
    },
    // 获取成交漏斗分析
    getDealFilters () {
      let params = {
        filter: this.filter
      }
      if (this.stores.length !== 0) {
        this.stores.forEach((item, index) => {
          index = index + 1
          params[`store${index}`] = item.key
        })
        this.$rest.dataAnalysis.getArriveToDeal(params).then(res => {
          if (res.code === 0) {
            this.subStores = res.data
            this.show = false
          } else {
            this.showToast(res.message)
          }
        })
      } else {
        this.subStores = []
        this.show = false
      }
    },
    // 获取潜客线索成交漏斗分析
    getClueFilters () {
      let params = {
        filter: this.filter
      }
      if (this.clues.length !== 0) {
        this.clues.forEach((item, index) => {
          index = index + 1
          params[`store${index}`] = item.key
        })
        this.$rest.dataAnalysis.getClueStatistical(params).then(res => {
          if (res.code === 0) {
            this.subClues = res.data
            this.showClue = false
          } else {
            this.showToast(res.message)
          }
        })
      } else {
        this.subClues = []
        this.showClue = false
      }
    },
    onTabChange (newParams) {
      this.filter = newParams.filter
      this.flagA = newParams.bool
      this.getData()
      this.getCurrentTime()
    },
    getData () {
      if (this.$refs.group) {
        this.$refs.group.query('groupConfig', { filter: this.filter })
      }
      if (this.$refs.clues) {
        this.$refs.clues.query('culeArrived', { filter: this.filter })
      }
      this.getDealFilters()
      this.getClueFilters()
    },
    getCurrentTime () {
      let date = new Date()
      switch (this.filter) {
        case 'last_month':
          let lastMonty = new Date(date.getFullYear(), date.getMonth() - 1, date.getDate())
          this.day = util.formatTime(lastMonty, 'yyyy-MM')
          break
        case 'yestoday':
          let yesterday = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1)
          this.day = util.formatTime(yesterday, 'yyyy-MM-dd')
          break
        case 'today':
          this.day = util.formatTime(date, 'yyyy-MM-dd')
          break
        default:
          this.day = util.formatTime(date, 'yyyy-MM')
      }
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less">
  @import "../../stylesheets/modules/data/carData.less";
  .th-span, .tr-span {
    width: 1.5rem;
    display: inline-block;
  }
  .popup0 {
    .weui_cells_checkbox {
      max-height: 480/@w2;
      overflow-y: scroll;
      &:after {
        border-bottom: none;
      }
    }
  }
  .add-stores {
    padding: 0.4rem;
    li {
      height: 56/@w2;
      line-height: 56/@w2;
      // padding: 0.1rem;
      background: #f1f4fb;
      margin-bottom: 0.3rem;
      text-align: center;
    }
    .add_store_btn {
      width: 100%;
      margin: 0;
      border-radius: 2px;
    }
  }
  .filters {
    padding: 0 0.4rem;
    .weui_cell {
      padding: 0;
      position: relative;
    }
    .store-name {
      line-height: 0.5rem;
      width: 23%;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      text-align: left;
      position: absolute;
      &:after {
        background: transparent;
      }
    }
    .store-name0 {
      left: 30%;
    }
    .store-name1 {
      left: 55%;
    }
    .store-name2 {
      left: 75%;
    }
    .weui_cell_bd>div span, .weui_cell_bd>.title, .weui_cell_bd .store-name {
      color: #5b6984;
    }
    .weui_cells {
      font-size: 26/@w2;
      &:before {
        border-top: none;
      }
    }
    .one em.p-em{
      margin-left: 0;
    }
    .two em.p-em{
      margin-left: 16/@w2;
    }
    .two em.p-em1 {
      margin-left: 30/@w2;
    }
    .two em.p-em2 {
      margin-left: 32/@w2;
    }
    .three em.p-em{
      margin-left: 32/@w2;
    }
    .three em.p-em1 {
      margin-left: 60/@w2;
    }
    .three em.p-em2 {
      margin-left: 64/@w2;
    }
    em{
      text-align: center;
      position: relative;
      &:before,&:after{
        content: "";
        position: absolute;
        background: url("../../stylesheets/images/manage/triangle.png") no-repeat;
        width: 16/@w2;
        height:96/@w2;
        background-size:100% 100%;
        top:0;
      }
      &:before{
        left: 0;
      }
      &:after{
        right: 0;
        -webkit-transform: scale(-1,1);
      }
    }
    .title{
      span{
        display: inline-block; width: 158/@w2;
      }
    }
    .one {
      em{ background: #d7e3ff; display: inline-block; width: 158/@w2;
        margin-left: 7/@w2;}
    }
    .two {
      em{ background: #e3ebff; display: inline-block; width: 126/@w2;
        margin-left: 38/@w2;}
    }
    .three {
      em{ background: #f3f6ff; display: inline-block; width: 94/@w2;
        margin-left: 70/@w2;}
    }
    p > span{
      &:nth-child(1){
        width: 202/@w2; display: inline-block;
        text-indent: 30/@w2;
      }
    }
    span,em{ float: left;line-height: 96/@w2;}
    em{width: 164/@w2; line-height: 96/@w2;
      position: relative;}
  }
  .weui_btn_plain_primary {
    border: 1px solid #5890fe!important;
    color: #5890fe!important;
  }
  .store-icon {
    display: inline-block;
    margin-right: 14/@w2;
    margin-top: -3px;
    background: url("../../stylesheets/images/icon/store_icons.png") 0 0 no-repeat;
    width: 13px;
    height: 13px;
    vertical-align: middle;
    background-size: 39px 14px;
  }
  .store-add-icon {
    background-position: 0 0;
  }
  .store-edit-icon {
    background-position: -26px 0;
  }
</style>
